import {useState} from 'react';
import AppTooltip from '../../../../../components/common/AppTooltip';
import {SVG} from '../../../../../constants/assetLists';
import ChecklistApproval from '../../Modals/ChecklistApproval';

type Props = {
  list: {
    _id: string;
    title: string;
    description: string;
    createdBy: string;
  };
};

function ChecklistBox({list}: Props) {
  const [showApproveChecklist, setShowApproveChecklist] = useState(false);

  const handleListClick = () => {
    setShowApproveChecklist(true);
  };

  return (
    <>
      <button
        className="flex items-center gap-2 bg-gray80 px-[5px] py-[3px] rounded-[8px]"
        onClick={handleListClick}>
        <div className="w-[18px] h-[18px]">
          <img
            src={SVG.listIcon}
            alt="icon"
            className="w-full h-full object-contain"
          />
        </div>

        <AppTooltip title={list?.title?.length > 25 ? list?.title : ''}>
          <span className="underline text-darkBlue cursor-pointer">
            {list?.title?.length > 25
              ? list?.title?.slice(0, 25) + '...'
              : list?.title}
          </span>
        </AppTooltip>
      </button>

      <ChecklistApproval
        checklistId={list?._id}
        open={showApproveChecklist}
        onClose={() => setShowApproveChecklist(false)}
      />
    </>
  );
}

export default ChecklistBox;
